import React from "react";
import SubPageLayout from "../components/SubPageLayout";
import WaterExplained from "../components/WaterExplained";
import Approach from "../components/home/Approach";
import FinalCta from "../components/home/FinalCta";
import { WATER_EXPLAINED } from "../data";

export default function SystemsExplainedPage() {
  return (
    <SubPageLayout testid="systems-explained-page" eyebrow="How It Works" title="Our Systems, Explained." subtitle={WATER_EXPLAINED.intro}
      metaDescription="How Honest Water LLC whole-home filtration, water softening and reverse osmosis systems work, and what to expect from your water test and installation.">
      <Approach id="process" />
      <WaterExplained hideIntro />
      <FinalCta />
    </SubPageLayout>
  );
}
